import "../../styles/BirthdayParty/BirthdayPartyCommons.css"
import "../../styles/Birthday.css"

import React, { useEffect, useState, useCallback, useRef } from "react"

function BirthdayScreen() {
    const [registeredUserCount, setRegisteredUserCount] = useState(0)
    const [websocketStatus, setWebsocketStatus] = useState("connecting")
    const [messages, setMessages] = useState([])
    const [photobooth, setPhotobooth] = useState("none")
    const [isPause, setPause] = useState(false)
    const [sideInfo, setSideInfo] = useState("qrcode")

    const sideInfoRef = useRef("qrcode")

    useEffect(() => {
        sideInfoRef.current = sideInfo
    }, [sideInfo])

    const [displayedPlayers, setDisplayedPlayers] = useState([])
    const [playersAnimationRunning, setPlayersAnimationRunning] = useState(false)
    const [players, setPlayers] = useState({
        allPlayers: [],
        selected: [],
        hideKenzo: false,
        quantity: 0
    })

    const [item, setItem] = useState({
        items: [],
        item: null
    })

    const [timerRemaining, setTimerRemaining] = useState(0)
    const timerIntervalRef = useRef(null)

    const [displayedItem, setDisplayedItem] = useState(null)
    const [itemAnimationRunning, setItemAnimationRunning] = useState(false)

    const itemShuffleIntervalRef = useRef(null)
    const itemRevealTimeoutRef = useRef(null)

    const websocketRef = useRef(null)
    const reconnectTimeoutRef = useRef(null)
    const shouldReconnectRef = useRef(true)

    const connectWebSocket = useCallback(() => {
        if(websocketRef.current && (websocketRef.current.readyState === WebSocket.OPEN || websocketRef.current.readyState === WebSocket.CONNECTING)) {
            return
        }

        setWebsocketStatus("connecting")

        const protocol = window.location.protocol === "https:" ? "wss" : "ws"
        const websocketUrl = `${protocol}://api.kenzo-simon.fr/birthday/party/websocket`

        const socket = new WebSocket(websocketUrl)
        websocketRef.current = socket

        socket.onopen = () => {
            console.log("Connected");
            setWebsocketStatus("connected")
        }

        socket.onmessage = (event) => {
            if(websocketRef.current !== socket) return

            try {
                const message = JSON.parse(event.data)

                switch(message.type) {
                    case "birthday:users-count":
                        setRegisteredUserCount(message.data.count)

                        setMessages((prev) => [...prev, { user: "system", userPhoto: message.data.newUserPhoto, message: `${message.data.newUser} a rejoint le chat !`, type: "system", sendAt: Date.now() }])
                        break;

                    case "birthday:new-message":
                        setMessages((prev) => [...prev, { user: message.data.user, userPhoto: message.data.userPhoto, message: message.data.message, type: "text", sendAt: message.sentAt }])
                        break;

                    case "birthday:new-photo":
                        setMessages((prev) => [...prev, {  user: message.data.user, userPhoto: message.data.userPhoto, photo: message.data.photo, type: "photo", sendAt: message.sentAt  }])
                        break;

                    case "birthday:new-photobooth":
                        console.log(message);
                        const photoboothDisplayed = handleSetSideInfoPhotobooth()

                        if(!photoboothDisplayed) break;

                        setPhotobooth(message.data.montage)

                        setTimeout(() => {
                            setPhotobooth("")
                            setSideInfo("qrcode")
                        }, 10_000)

                        break;

                    case "birthday:player-list":
                        console.log(message);
                        const playerData = {
                            allPlayers: message.data.allPlayers,
                            players: message.data.players,
                            quantity: message.data.quantity,
                            hideKenzo: message.data.hideKenzo
                        }

                        setPlayers(playerData)
                        handleStartPlayers(playerData)
                        
                        break;

                    case "birthday:player-replaced":
                        console.log(message);
                        const { replaceId, newPlayer } = message.data

                        setDisplayedPlayers((currentPlayers) =>
                            currentPlayers.map((player) =>
                                player.internId === replaceId
                                    ? {
                                        ...newPlayer,
                                        revealed: true
                                    }
                                    : player
                            )
                        )

                        setPlayers((currentState) => ({
                            ...currentState,
                            players: currentState.players.map((player) =>
                                player.internId === replaceId
                                    ? newPlayer
                                    : player
                            )

                        }))

                        break;

                    case "birthday:item-selected":
                        const itemData = {
                            items: message.data.items,
                            item: message.data.item
                        }

                        setItem(itemData)
                        handleStartItem(itemData)
                        
                        break;

                    case "birthday:base-infos":
                        setRegisteredUserCount(message.data.usersCount)

                        const newMessages = message.data.lastMessages.map((msg) => {
                            return {
                                user: msg.authorName,
                                userPhoto: msg.authorPhotoUrl,
                                message: msg.content,
                                type: msg.type,
                                photo: msg.photo.url,
                                sendAt: msg.createdAt
                            }
                        })

                        setMessages(newMessages)

                        setPause(message.data.isPause)

                        break;

                    case "birthday:start-timer":
                        console.log(message);
                        const timer = message.data.timer

                        startTimer(timer, true)
                        
                        break;

                    case "birthday:setqrcode": 
                        setSideInfo("qrcode")
                        break;

                    case "birthday:change-pause":
                        setPause(message.data.newState)
                        break;

                    default: 
                        console.log("Event inconnu :", message);
                }

            } catch (error) {
                console.error(`Message WS invalid :`, error);
                
            }
        }

        socket.onerror = (error) => {
            console.error("Erreur WebSocket :", error)
        }

        socket.onclose = () => {
            console.log("WebSocket déconnecté")

            websocketRef.current = null
            setWebsocketStatus("disconnected")

            if(!shouldReconnectRef.current) {
                return
            }

            clearTimeout(reconnectTimeoutRef.current)

            reconnectTimeoutRef.current = setTimeout(() => {
                if(!websocketRef.current && shouldReconnectRef.current) {
                    connectWebSocket()
                }
            }, 3000)
        }
    }, [])

    useEffect(() => {
        shouldReconnectRef.current = true
        connectWebSocket()

        return () => {

            shouldReconnectRef.current = false
            clearTimeout(reconnectTimeoutRef.current)

            if(websocketRef.current) {
                websocketRef.current.close()
                websocketRef.current = null
            }
        }
    }, [connectWebSocket])

    // acitivities
    const handleSetSideInfoPhotobooth = () => {
        const currentSideInfo = sideInfoRef.current

        console.log("Side info actuelle :", currentSideInfo)

        if (currentSideInfo !== "qrcode") {
            return false
        }

        sideInfoRef.current = "photobooth"
        setSideInfo("photobooth")

        return true
    }

    const handleStartPlayers = ({
        allPlayers,
        players: selectedPlayers,
        quantity,
        hideKenzo
    }) => {
        setSideInfo("players")
        setPlayersAnimationRunning(true)

        const filteredAllPlayers = allPlayers.filter((player) => {
            return !(hideKenzo && player.firstName === "Kenzo")
        })

        const filteredSelectedPlayers = selectedPlayers.filter((player) => {
            return !(hideKenzo && player.firstName === "Kenzo")
        })

        if (
            filteredAllPlayers.length === 0 ||
            filteredSelectedPlayers.length === 0
        ) {
            setDisplayedPlayers([])
            setPlayersAnimationRunning(false)
            return
        }

        const displayedQuantity = Math.min(
            Number(quantity) || filteredSelectedPlayers.length,
            filteredSelectedPlayers.length
        )

        const initialPlayers = Array.from(
            { length: displayedQuantity },
            () => {
                const randomIndex = Math.floor(
                    Math.random() * filteredAllPlayers.length
                )

                return {
                    ...filteredAllPlayers[randomIndex],
                    revealed: false
                }
            }
        )

        setDisplayedPlayers(initialPlayers)

        const shuffleInterval = setInterval(() => {
            setDisplayedPlayers((currentPlayers) =>
                currentPlayers.map((player) => {
                    if (player.revealed) {
                        return player
                    }

                    const randomIndex = Math.floor(
                        Math.random() * filteredAllPlayers.length
                    )

                    return {
                        ...filteredAllPlayers[randomIndex],
                        revealed: false
                    }
                })
            )
        }, 50)

        const revealTimeout = setTimeout(() => {
            let currentRevealIndex = 0

            const revealNextPlayer = () => {
                setDisplayedPlayers((currentPlayers) =>
                    currentPlayers.map((player, index) => {
                        if (index !== currentRevealIndex) {
                            return player
                        }

                        return {
                            ...filteredSelectedPlayers[currentRevealIndex],
                            revealed: true
                        }
                    })
                )

                currentRevealIndex++

                if (currentRevealIndex >= displayedQuantity) {
                    clearInterval(shuffleInterval)

                    setDisplayedPlayers(
                        filteredSelectedPlayers
                            .slice(0, displayedQuantity)
                            .map((player) => ({
                                ...player,
                                revealed: true
                            }))
                    )

                    setPlayersAnimationRunning(false)
                    return
                }

                setTimeout(revealNextPlayer, 500)
            }

            revealNextPlayer()
        }, 3000)

        return () => {
            clearInterval(shuffleInterval)
            clearTimeout(revealTimeout)
        }
    }

    const startTimer = (duration, sideInfoChange = true) => {
        let durationInSeconds = 0

        if (duration === "30s") {
            durationInSeconds = 30
        } else if (duration === "1m") {
            durationInSeconds = 60
        } else if (duration === "2m") {
            durationInSeconds = 120
        } else if (duration === "5m") {
            durationInSeconds = 300
        } else {
            durationInSeconds = 45
        }

        if (timerIntervalRef.current) {
            clearInterval(timerIntervalRef.current)
            timerIntervalRef.current = null
        }

        if(sideInfoChange === true) {
            setSideInfo("timer")
        }
        
        setTimerRemaining(durationInSeconds)

        timerIntervalRef.current = setInterval(() => {
            setTimerRemaining((currentTime) => {
                if (currentTime <= 1) {
                    clearInterval(timerIntervalRef.current)
                    timerIntervalRef.current = null

                    return 0
                }

                return currentTime - 1
            })
        }, 1000)
    }

    const getNumber = (value, index) => {
        if(index > 2) index = 2
        if(index < 1) index = 1

        const valueToString = String(value)
        let sliced = valueToString.split("")

        if(sliced.length == 1) {
            sliced = ["0", sliced[0]]
        }

        return sliced[index - 1]
    }

    const timeBoxElement = (type = "m", name) => {
        const timerMinutes = Math.floor(timerRemaining / 60)
        const timerSeconds = timerRemaining % 60

        return (
            <>
            <div className="time-box">
                <div className="values-box">
                    <div className="first-value">
                        <span className="text4 keyword2">
                            {getNumber(type === "m" ? timerMinutes : timerSeconds, 1)}
                        </span>
                    </div>

                    <div className="second-value">
                        <span className="text4 keyword2">
                            {getNumber(type === "m" ? timerMinutes : timerSeconds, 2)}
                        </span>
                    </div>
                </div>

                <div className="indicator">
                    <span className="text3">
                        {name}
                    </span>
                </div>
            </div>
            </>
        )
    }

    const handleStartItem = ({
        items,
        item: selectedItem
    }) => {
        if (!Array.isArray(items) || items.length === 0 || !selectedItem) {
            setDisplayedItem(null)
            setItemAnimationRunning(false)
            return
        }

        // Nettoie une éventuelle animation précédente
        if (itemShuffleIntervalRef.current) {
            clearInterval(itemShuffleIntervalRef.current)
            itemShuffleIntervalRef.current = null
        }

        if (itemRevealTimeoutRef.current) {
            clearTimeout(itemRevealTimeoutRef.current)
            itemRevealTimeoutRef.current = null
        }

        setSideInfo("item")
        setItemAnimationRunning(true)

        const availableItems = items.filter((currentItem) => {
            return !currentItem.used
        })

        /*
        * Si l'item sélectionné est déjà noté used par le backend,
        * on le garde tout de même pour la révélation finale.
        */
        const shuffledItems =
            availableItems.length > 0
                ? availableItems
                : items

        const getRandomItem = () => {
            const randomIndex = Math.floor(
                Math.random() * shuffledItems.length
            )

            return shuffledItems[randomIndex]
        }

        setDisplayedItem({
            ...getRandomItem(),
            revealed: false
        })

        itemShuffleIntervalRef.current = setInterval(() => {
            setDisplayedItem({
                ...getRandomItem(),
                revealed: false
            })
        }, 50)

        itemRevealTimeoutRef.current = setTimeout(() => {
            if (itemShuffleIntervalRef.current) {
                clearInterval(itemShuffleIntervalRef.current)
                itemShuffleIntervalRef.current = null
            }

            setDisplayedItem({
                ...selectedItem,
                revealed: true
            })

            setSideInfo("itemtimer")
            startTimer("45s", false)

            setItemAnimationRunning(false)
            itemRevealTimeoutRef.current = null
        }, 5000)
    }

    return (
        <div className="body body-birthday-special body-birthday_screen">
            {isPause ? (
                <>
                <section className="screen-content">
                    <h1 className="screen-waiting">
                        Bienvenue !
                    </h1>
                </section>
                </>
            ) : (
                <>
                <section className="screen-content">
                    <div className="screen-chat">
                        <div className="chat-header">
                            <span className="birthscreen-text birthscreen-text-md birthscreen-text-500 chat-header-info">État de la connexion : {websocketStatus === "connecting" ? "🟡" : websocketStatus === "connected" ? "🟢" : "🔴"}</span>
                        </div>

                        <div className="chat-body">
                            {messages.map((msg, index) => (
                                <React.Fragment key={index}>
                                    {msg.type === "system" ? (
                                        <>
                                        <div className="chat-system_message">
                                            <span className="chat-system_message-content">{msg.message}</span>
                                            <img
                                                src={`https://api.kenzo-simon.fr/${msg.userPhoto}`}
                                                className="chat-system_message-photo chat-big-img"
                                            />
                                        </div>
                                        </>
                                    ) : (
                                        <>
                                        <div className="chat-message">
                                            <div className="chat-message-user-infos">
                                                {/* <div className="chat-msgpart chat-msgpart-1">
                                                    <span className="chat-hour chat-info">
                                                        {String(new Date(msg.sendAt).getHours()).padStart(2, "0")}h{String(new Date(msg.sendAt).getMinutes()).padStart(2, "0")}
                                                    </span>
                                                </div> */}

                                                <div className="chat-msgpart chat-msgpart-2">
                                                    <img 
                                                        src={`https://api.kenzo-simon.fr/${msg.userPhoto}`}
                                                        width={"60px"}
                                                        height={"60px"}
                                                        className="chat-profile_picture"
                                                    />

                                                    <span className="chat-username">
                                                        {msg.user}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="chat-message-content">
                                                <div className="chat-msgpart chat-msgpart-3">
                                                    {msg.type === "text" ? (
                                                        <>
                                                            <span className="chat-message-text">{msg.message}</span>
                                                        </>
                                                    ) : (
                                                        <>
                                                        <img
                                                            className="chat-message-image"
                                                            src={`https://api.kenzo-simon.fr/${msg.photo}`}
                                                        />
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        </>
                                    )}
                                </React.Fragment>
                            ))}
                        </div>

                        <div className="chat-footer">
                            <span className="birthscreen-text birthscreen-text-md birthscreen-text-500 chat-footer-info">{registeredUserCount} participants en ligne</span>
                        </div>
                    </div>

                    <div className="screen-infos">
                        <div className="screen-infos-body">
                            {sideInfo === "qrcode" ? (
                                <>
                                <div className="side-info-box qr-code-box">
                                    <span className="qr-code-title">
                                        Scannez pour rejoindre !
                                    </span>

                                    <img
                                        src="/qr-code.png"
                                        className="qr-code-image"
                                        width={"100px"}
                                        height={"100px"}
                                    />

                                    <span className="qr-code-link">
                                        party.kenzo-simon.fr
                                    </span>
                                </div>
                                </>
                            ) : sideInfo === "photobooth" ? (
                                <>
                                <div className="side-info-box photobooth-box">
                                    <span className="qr-code-title">
                                        Nouveau photobooth reçu !
                                    </span>

                                    <img
                                        src={`https://api.kenzo-simon.fr/${photobooth}`}
                                        className="screen-photobooth-image"
                                        width={"100px"}
                                        height={"100px"}
                                    />
                                </div>
                                </>
                            ) : sideInfo === "players" ? (
                                <>
                                <div className="side-info-box players-info-box">
                                    {displayedPlayers.map((player, index) => (
                                        <React.Fragment key={index}>
                                             <div
                                                className={`player-line ${
                                                    player.revealed ? "revealed" : "shuffling"
                                                }`}
                                            >
                                                <span className="player-name">
                                                    {/* {index + 1}.  */}
                                                    {player.firstName} {player.lastName}
                                                </span>
                                            </div>
                                        </React.Fragment>
                                    ))}
                                </div>
                                </>
                            ) : sideInfo === "timer" ? (
                                <>
                                <div className="side-info-box timer-info-box screen-timer">
                                    <div className="timer-units little-units">
                                        {timeBoxElement("m", "Minutes")}

                                        <div className="time-separator">
                                            <span className="text4">:</span>
                                        </div>

                                        {timeBoxElement("s", "Secondes")}

                                    </div>
                                </div>
                                </>
                            ) : sideInfo === "item" ? (
                                <>
                                <div className="side-info-box item-info-box">
                                    <div className="item-header">

                                    </div>

                                    <div className="item-body">
                                        <span className="item-emoji">
                                            {displayedItem.emoji}
                                        </span>
                                    </div>

                                    <div className="item-footer">
                                        <span className="item-title">
                                            {displayedItem.name}
                                        </span>
                                    </div>
                                </div>
                                </>
                            ) : sideInfo === "itemtimer" ? (
                                <>
                                <div className="side-info-box itemtimer-info-box">
                                    <div className="item-header">
                                        <div className="timer-units little-units">
                                            {timeBoxElement("m", "Minutes")}

                                            <div className="time-separator">
                                                <span className="text4">:</span>
                                            </div>

                                            {timeBoxElement("s", "Secondes")}

                                        </div>
                                    </div>

                                    <div className="item-body">
                                        <span className="item-emoji">
                                            {displayedItem.emoji}
                                        </span>
                                    </div>

                                    <div className="item-footer">
                                        <span className="item-title">
                                            {displayedItem.name}
                                        </span>
                                    </div>
                                </div>
                                </>
                            ) : (
                                <>
                                <div className="side-info-box qr-code-box">
                                    <span className="qr-code-title">
                                        Scannez pour rejoindre !
                                    </span>

                                    <img
                                        src="/qr-code.png"
                                        className="qr-code-image"
                                        width={"100px"}
                                        height={"100px"}
                                    />

                                    <span className="qr-code-link">
                                        party.kenzo-simon.fr
                                    </span>
                                </div>
                                </>
                            )}
                        </div>
                    </div>
                </section>
                </>
            )}
        </div>
    )
}

export default BirthdayScreen